export default {
    continueReading: "To continue reading please",
    doYouHaveAnAccount: "Do you have an account?",
    loginHere: "Login Here",
    acceptAndContinueReading: "Accept and continue reading",
};
